import { render, staticRenderFns } from "./PayerDetails.vue?vue&type=template&id=6b6d93ce&scoped=true"
import script from "./PayerDetails.vue?vue&type=script&lang=js"
export * from "./PayerDetails.vue?vue&type=script&lang=js"
import style0 from "./PayerDetails.vue?vue&type=style&index=0&id=6b6d93ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6d93ce",
  null
  
)

export default component.exports